export const shop_candle = [
  {
    pImg: "https://cdn-fsly.yottaa.net/5d669b394f1bbf7cb77826ae/www.bathandbodyworks.com/v~4b.216/dw/image/v2/BBDL_PRD/on/demandware.static/-/Sites-master-catalog/default/dwded231f1/crop/026531868_crop.jpg?sw=500&sh=600&sm=fit&q=75&yocs=o_s_",
    category: "New!",
    id: "21",
    name: "Sweater Weather",
    category1: "3-Wick Candle",
    Amount: "13.50",
    Rating: "7",
  },
  {
    pImg: "https://cdn-fsly.yottaa.net/5d669b394f1bbf7cb77826ae/www.bathandbodyworks.com/v~4b.216/dw/image/v2/BBDL_PRD/on/demandware.static/-/Sites-master-catalog/default/dwbe0e4c51/crop/026437364_crop.jpg?sw=500&sh=600&sm=fit&q=75&yocs=o_s_",
    category: "",
    id: "22",
    name: "Strawberry Pound Candle",
    category1: "Single Wick Candle",
    Amount: "15.50",
    Rating: "153",
  },
  {
    pImg: "https://cdn-fsly.yottaa.net/5d669b394f1bbf7cb77826ae/www.bathandbodyworks.com/v~4b.216/dw/image/v2/BBDL_PRD/on/demandware.static/-/Sites-master-catalog/default/dwa8ce685c/crop/026537636_crop.jpg?sw=500&sh=600&sm=fit&q=75&yocs=o_s_",
    category: "New!",
    id: "23",
    name: "Apple Orchard Lane",
    category1: "3-Wick Candle",
    Amount: "13.50",
    Rating: "13",
  },
  {
    pImg: "https://cdn-fsly.yottaa.net/5d669b394f1bbf7cb77826ae/www.bathandbodyworks.com/v~4b.216/dw/image/v2/BBDL_PRD/on/demandware.static/-/Sites-master-catalog/default/dw784b058a/crop/026553801_crop.jpg?sw=500&sh=600&sm=fit&q=75&yocs=o_s_",
    category: "New!",
    id: "24",
    name: "Walk in the Forest",
    category1: "Single Wick Candle",
    Amount: "15.50",
    Rating: "2",
  },
  {
    pImg: "https://cdn-fsly.yottaa.net/5d669b394f1bbf7cb77826ae/www.bathandbodyworks.com/v~4b.216/dw/image/v2/BBDL_PRD/on/demandware.static/-/Sites-master-catalog/default/dw4ca053bb/crop/026502620_crop.jpg?sw=500&sh=600&sm=fit&q=75&yocs=o_s_",
    category: "New!",
    id: "25",
    name: "Noise-Making Water Globe Raven Pedestal",
    category1: "3-Wick Candle Holder",
    Amount: "79.95",
    Rating: "14",
  },
  {
    pImg: "https://cdn-fsly.yottaa.net/5d669b394f1bbf7cb77826ae/www.bathandbodyworks.com/v~4b.216/dw/image/v2/BBDL_PRD/on/demandware.static/-/Sites-master-catalog/default/dwa415c4e9/crop/026529851_crop.jpg?sw=500&sh=600&sm=fit&q=75&yocs=o_s_",
    category: "New!",
    id: "26",
    name: "Haunted House Luminary",
    category1: "3-Wick Candle Holder",
    Amount: "200",
    Rating: "6",
  },
  {
    pImg: "https://cdn-fsly.yottaa.net/5d669b394f1bbf7cb77826ae/www.bathandbodyworks.com/v~4b.216/dw/image/v2/BBDL_PRD/on/demandware.static/-/Sites-master-catalog/default/dw90fbce9c/crop/026536756_crop.jpg?sw=500&sh=600&sm=fit&q=75&yocs=o_s_",
    category: "New!",
    id: "27",
    name: "Leaves",
    category1: "3-Wick Candle",
    Amount: "13.50",
    Rating: "6",
  },
  {
    pImg: "https://cdn-fsly.yottaa.net/5d669b394f1bbf7cb77826ae/www.bathandbodyworks.com/v~4b.216/dw/image/v2/BBDL_PRD/on/demandware.static/-/Sites-master-catalog/default/dwce733a95/crop/026544277_crop.jpg?sw=500&sh=600&sm=fit&q=75&yocs=o_s_",
    category: "New!",
    id: "28",
    name: "Pumpkin Pecan Waffles",
    category1: "3-Wick Candle",
    Amount: "13.50",
    Rating: "17",
  },
  {
    pImg: "https://cdn-fsly.yottaa.net/5d669b394f1bbf7cb77826ae/www.bathandbodyworks.com/v~4b.216/dw/image/v2/BBDL_PRD/on/demandware.static/-/Sites-master-catalog/default/dw7ba36a12/hires/026441623_alt_1.jpg?sh=413&yocs=o_s_",
    category: "New!",
    id: "29",
    name: "Champagne Toast",
    category1: "Single Wick Candle",
    Amount: "13.50",
    Rating: "1",
  },
  {
    pImg: "https://cdn-fsly.yottaa.net/5d669b394f1bbf7cb77826ae/www.bathandbodyworks.com/v~4b.216/dw/image/v2/BBDL_PRD/on/demandware.static/-/Sites-master-catalog/default/dwa5dea731/crop/026437366_crop.jpg?sw=500&sh=600&sm=fit&q=75&yocs=o_s_",
    category: "New",
    id: "30",
    name: "Mahogany Teakwood",
    category1: "Single Wick Candle",
    Amount: "17.95",
    Rating: "9",
  },
  {
    pImg: "https://cdn-fsly.yottaa.net/5d669b394f1bbf7cb77826ae/www.bathandbodyworks.com/v~4b.216/dw/image/v2/BBDL_PRD/on/demandware.static/-/Sites-master-catalog/default/dwdfe0df3d/crop/026437376_crop.jpg?sw=500&sh=600&sm=fit&q=75&yocs=o_s_",
    category: "New",
    id: "31",
    name: "Eucalyptus Spearmint",
    category1: "Single Wick Candle",
    Amount: "13.50",
    Rating: "43",
  },
  {
    pImg: "https://cdn-fsly.yottaa.net/5d669b394f1bbf7cb77826ae/www.bathandbodyworks.com/v~4b.216/dw/image/v2/BBDL_PRD/on/demandware.static/-/Sites-master-catalog/default/dwfdf75f06/crop/026426977_crop.jpg?sw=500&sh=600&sm=fit&q=75&yocs=o_s_",
    category: "New",
    id: "32",
    name: "Fresh Cut Lilacs",
    category1: "Single Wick Candle",
    Amount: "17.50",
    Rating: "7",
  },
  {
    pImg: "https://cdn-fsly.yottaa.net/5d669b394f1bbf7cb77826ae/www.bathandbodyworks.com/v~4b.216/dw/image/v2/BBDL_PRD/on/demandware.static/-/Sites-master-catalog/default/dw257db0ed/crop/026480789_crop.jpg?sw=500&sh=600&sm=fit&q=75&yocs=o_s_",
    category: "Lavender Vanilla",
    id: "33",
    name: "Single Wick Candle",
    category1: "candle",
    Amount: "13.50",
    Rating: "232",
  },
  {
    pImg: "https://cdn-fsly.yottaa.net/5d669b394f1bbf7cb77826ae/www.bathandbodyworks.com/v~4b.216/dw/image/v2/BBDL_PRD/on/demandware.static/-/Sites-master-catalog/default/dw018cbcb6/crop/026437372_crop.jpg?sw=500&sh=600&sm=fit&q=75&yocs=o_s_",
    category: "New Fragrance",
    id: "34",
    name: "Pink Pineapple Sunrise",
    category1: "Single Wick Candle",
    Amount: "14.99",
    Rating: "70",
  },
  {
    pImg: "https://cdn-fsly.yottaa.net/5d669b394f1bbf7cb77826ae/www.bathandbodyworks.com/v~4b.216/dw/image/v2/BBDL_PRD/on/demandware.static/-/Sites-master-catalog/default/dw3a3f2729/crop/026448739_crop.jpg?sw=500&sh=600&sm=fit&q=75&yocs=o_s_",
    category: "New Fragrance",
    id: "35",
    name: "Iced Lemon Pound Cake",
    category1: "Single Wick Candle",
    Amount: "19.95",
    Rating: "58",
  },
  {
    pImg: "https://cdn-fsly.yottaa.net/5d669b394f1bbf7cb77826ae/www.bathandbodyworks.com/v~4b.216/dw/image/v2/BBDL_PRD/on/demandware.static/-/Sites-master-catalog/default/dw536b669c/crop/026480791_crop.jpg?sw=500&sh=600&sm=fit&q=75&yocs=o_s_",
    category: "New",
    id: "36",
    name: "Water Globe Pineapple",
    category1: "3-Wick Candle Holder",
    Amount: "9.99",
    Rating: "5",
  },
  {
    pImg: "https://cdn-fsly.yottaa.net/5d669b394f1bbf7cb77826ae/www.bathandbodyworks.com/v~4b.216/dw/image/v2/BBDL_PRD/on/demandware.static/-/Sites-master-catalog/default/dw49cac0a3/crop/026413479_crop.jpg?sw=500&sh=600&sm=fit&q=75&yocs=o_s_",
    category: "New!",
    id: "37",
    name: "The Perfect Summer",
    category1: "Single Wick Candle",
    Amount: "16.99",
    Rating: "3",
  },
  {
    pImg: "https://cdn-fsly.yottaa.net/5d669b394f1bbf7cb77826ae/www.bathandbodyworks.com/v~4b.216/dw/image/v2/BBDL_PRD/on/demandware.static/-/Sites-master-catalog/default/dw02c8940e/crop/026517154_crop.jpg?sw=500&sh=600&sm=fit&q=75&yocs=o_s_",
    category: "New!",
    id: "38",
    name: "Strawberry Pound Cake",
    category1: "Single Wick Candle",
    Amount: "14.55",
    Rating: "1",
  },
  {
    pImg: "https://www.justmylook.com/images/yankee-candle-floral-candy-large-jar-candle-p13501-22316_medium.jpg",
    category: "New Fragrance",
    id: "39",
    name: "Iced Lemon Pound Cake",
    category1: "3-Wick Candle",
    Amount: "25.99",
    Rating: "53",
  },
  {
    pImg: "https://cdn.shopify.com/s/files/1/0555/2277/products/MiaraCandleS2_360x.jpg?v=1634124245",
    category: "New!",
    id: "40",
    name: "Raspberry Mimosa",
    category1: "Single Wick Candle",
    Amount: "25.99",
    Rating: "5",
  },
];
